import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import HandArrow from "./HandArrow";
import AllergensToggle from "./AllergensToggle";
import { track } from "@/lib/analytics";

const item = {
  hidden: { opacity: 0, y: 24 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.45, delay: i * 0.08, ease: "easeOut" } }),
};

export default function DirtySidesSection({ items }) {
  return (
    <section id="dirty-sides" className="relative bg-[#FFC20E] grain py-14 sm:py-20">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 relative z-10">
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6">
          <div>
            <span className="font-display font-bold uppercase tracking-[0.3em] text-sm text-[#0C0C0C]/70">IL MENU</span>
            <h2 className="font-display font-black uppercase display-tight text-6xl sm:text-8xl text-[#0C0C0C] mt-1" data-testid="dirty-sides-section-title">
              DIRTY SIDES
            </h2>
            <p className="font-display font-extrabold uppercase text-xl sm:text-2xl text-[#0C0C0C] mt-2 leading-tight">
              STESSA VOGLIA.<br />ALTRI MORSI.
            </p>
          </div>
          <div className="relative flex items-center gap-2 self-start">
            <span className="font-hand text-2xl sm:text-3xl font-bold text-[#0C0C0C] -rotate-3 leading-tight">
              CROCCANTI<br />IRRESISTIBILI<br />SEMPRE UNGRIP
            </span>
            <HandArrow className="w-14 h-9 rotate-[120deg]" />
          </div>
        </div>

        <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-8">
          {items.map((p, i) => (
            <motion.article
              key={p.id}
              variants={item}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.2 }}
              custom={i}
              whileHover={{ y: -6, scale: 1.02 }}
              transition={{ duration: 0.25, ease: "easeOut" }}
              className="text-center"
              data-testid={`dirty-side-${p.slug}`}
            >
              <div className="aspect-square overflow-hidden rounded-2xl bg-white/20 mb-3">
                <img
                  src={p.image}
                  alt={p.name}
                  className="w-full h-full object-cover mix-blend-multiply"
                  loading="lazy"
                  onMouseEnter={() => track("product_view", { product: p.slug })}
                />
              </div>
              <div className="flex items-center justify-center gap-2">
                <h3 className="font-display font-black uppercase text-xl sm:text-2xl text-[#0C0C0C] leading-none">{p.name}</h3>
                <button
                  aria-label={`Ordina ${p.name}`}
                  className="w-8 h-8 rounded-full border-2 border-[#0C0C0C] text-[#0C0C0C] flex items-center justify-center hover:bg-[#0C0C0C] hover:text-[#FFC20E] transition-colors duration-200"
                  data-testid={`dirty-side-order-${p.slug}`}
                >
                  <ArrowRight size={15} />
                </button>
              </div>
              {p.description && (
                <p className="mt-2 text-sm text-[#0C0C0C]/75 font-semibold leading-snug max-w-[260px] mx-auto" data-testid={`dirty-side-desc-${p.slug}`}>
                  {p.description}
                </p>
              )}
              {p.price != null && (
                <span className="mt-1 block font-display font-extrabold text-lg text-[#0C0C0C]" data-testid={`dirty-side-price-${p.slug}`}>
                  € {Number(p.price).toFixed(2)}
                </span>
              )}
              <AllergensToggle product={p} dark />
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
